import { useCapabilitiesStore } from '@/features/capabilities/capabilities.store'
import { useIsLandlord } from '@/features/auth/useSession'
import type { Capabilities } from '@/features/capabilities/capabilities'

/** A single key, so a component re-renders only when the answer it reads changes. */
export function useCapability<K extends keyof Capabilities>(key: K): Capabilities[K] {
  return useCapabilitiesStore((s) => s.capabilities[key])
}

/** The whole block, for the few places that need more than one (the KYC hub). */
export function useCapabilities(): Capabilities {
  return useCapabilitiesStore((s) => s.capabilities)
}

// Whether this person has any verification surface (`kyc || payouts`): the one predicate every KYC hub entry point asks.
// A tenant never has a payout account, so for them it is just `kyc`.
export function useHasVerification(): boolean {
  const caps = useCapabilities()
  const isLandlord = useIsLandlord()
  return caps.kyc || (isLandlord && caps.payouts)
}
